import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import LikeTwoToneSvg from "@ant-design/icons-svg/es/asn/LikeTwoTone";
import AntdIcon from "../components/AntdIcon";
var LikeTwoTone = function LikeTwoTone(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: LikeTwoToneSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  LikeTwoTone.displayName = 'LikeTwoTone';
}
export default /*#__PURE__*/React.forwardRef(LikeTwoTone);